export type ColorName = keyof typeof colors;

export const colors = {
  whiteHover: 'rgba(245, 245, 245, 1)',

  black04: 'rgba(0, 0, 0, 0.04)',
  black10: 'rgba(0, 0, 0, 0.1)',
  black30: 'rgba(0, 0, 0, 0.3)',
  black40: 'rgba(0, 0, 0, 0.4)',
  black60: 'rgba(0, 0, 0, 0.6)',
  black90: 'rgba(0, 0, 0, 0.9)',
  black100: 'rgba(0, 0, 0, 1)',

  white10: 'rgba(255, 255, 255, 0.1)',
  white30: 'rgba(255, 255, 255, 0.3)',
  white90: 'rgba(255, 255, 255, 0.9)',
  white100: 'rgba(255, 255, 255, 1)',

  highlight10: 'rgba(255, 204, 0, 0.1)',
  highlight: 'rgba(255, 204, 0, 1)',
  highlightHover: 'rgba(255, 194, 0, 1)',
  highlightFocus: 'rgba(255, 184, 0, 1)',
  highlightBlue: 'rgba(48, 158, 214, 1)',
  highlightRed: 'rgba(204, 51, 51, 1)',

  lightGreen: 'rgba(149, 193, 31, 1)',

  success: 'rgba(46, 125, 50, 1)',
  error: 'rgba(204, 51, 51, 1)',
  caution: 'rgba(241, 135, 0, 1)',
  disabled: 'rgb(245,245,245)',

  none: 'none',

  /**
   * Additional fahrzeugplattform-specific colors
   */
  greyMedium: 'rgb(229, 229, 229)',
  // #666
  greyDevil: 'rgb(102,102,102)'
};
